module.exports = __webpack_public_path__ + "img/mat_105.4424decb.png";